const getters = {
  events: state => state.events,
  eventNames: state => state.event_names,
  eventTypes: state => state.event_types,
}

export default getters
